export default {
  app: {
    colors: {
      primary: "#6FB0F9",
      secondary: "#798892",
      success: "#26CD5F",
      info: "#10CFD0",
      warning: "#EBB834",
      danger: "#FF5574",
      inverse: "#30324C",
      default: "#9083F7"
    },
    chartColors: {
      axisColor: '#8EA1AB'
    }
  }
};